import React from 'react';
import { connect } from 'react-redux';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';

const MexicoCashChekOutPopup = (props) => {
    return (
        <ComplexPopup withoutButton popupRef={props.popupRef}>
            <DangerouslyHtml dangerouslyHtml={props.cashPickups} />
        </ComplexPopup>
    );
};
const mapStateToProps = ({ messages }) => {
    return {
        cashPickups: messages.pageMessages.cashPickups,
    };
};
export default connect(mapStateToProps)(MexicoCashChekOutPopup);
